export default __webpack_public_path__ + "static/media/library.4095d867.svg";